import { ApiResponse, CustomQueryOptions } from '@/shared/types';
import { useQuery } from '@tanstack/react-query';
import {requestHost} from '@waka/host/client';
import {z} from 'zod';

interface GetTTSVoiceUrlParams {
  voice: string;
  speedFactor: number;
  emotion: string;
  language: string;
  pitch?: number;
}

type ResponseType = ApiResponse<string>;

export const getTTSVoiceUrlApi = async (params: GetTTSVoiceUrlParams) => {
  try {
    const result=await requestHost({method:'GET',path:'/__waka/voice-preview',params});
    return z.object({status:z.string(),code:z.number(),message:z.string(),data:z.string()}).parse(result);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const QueryKeyUseGetTTSVoiceUrlApi = 'getTTSVoiceUrl' as const;

export const useGetTTSVoiceUrlApi = (
  params: GetTTSVoiceUrlParams,
  queryOptions?: CustomQueryOptions<ResponseType>,
) => {
  const { queryKey, ...rest } = queryOptions ?? {};

  return useQuery({
    queryKey: [
      QueryKeyUseGetTTSVoiceUrlApi,
      params.voice,
      params.emotion,
      params.language,
      params.speedFactor,
      params.pitch ?? null,
      ...(queryKey ?? []),
    ],
    queryFn: () => getTTSVoiceUrlApi(params),
    retry:false,
    ...rest,
  });
};
